import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-stripe-insufficient-funds-dialog',
  templateUrl: './stripe-insufficient-funds-dialog.component.html',
  styleUrls: ['./stripe-insufficient-funds-dialog.component.scss'],
})
export class StripeInsufficientFundsDialogComponent
  implements OnInit, OnDestroy
{
  private user: User;
  private subs: Subscription[] = [];
  constructor(
    private userDAO: UserDAO,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.user = this.userDAO.getCurrentUser();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  viewStripeDashClick(): void {
    window.open(
      this.data.isProd
        ? 'https://dashboard.stripe.com/topups'
        : 'https://dashboard.stripe.com/test/topups',
    );
  }
}
